import React from "react";

import { translate } from "react-i18next";

import { useBankingContent } from "src/banking/BankingContentContext";
import { Box, Text } from "src/components";
import { Body } from "src/components/Content";

const EnrollComplete = () => {
  const pageData = useBankingContent();

  return pageData.loginBoxContent ? (
    <Box height="100vh">
      <Body
        padded={false}
        content={pageData.enrollmentCompleteContentMobile.content}
      />
    </Box>
  ) : null;
};

export default translate("translations")(EnrollComplete);



// WEBPACK FOOTER //
// ./src/banking/authentication/Enroll/EnrollComplete.js